import { render, staticRenderFns } from "./MeterRealTimeAlarmList.vue?vue&type=template&id=c0605c60&scoped=true"
import script from "./MeterRealTimeAlarmList.vue?vue&type=script&lang=js"
export * from "./MeterRealTimeAlarmList.vue?vue&type=script&lang=js"
import style0 from "./MeterRealTimeAlarmList.vue?vue&type=style&index=0&id=c0605c60&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0605c60",
  null
  
)

export default component.exports